<template>
    <div class="app-header">
        <van-icon
                @click="goBack"
                class="back-icon"
                size="0.5rem"
                color="#fff"
                name="arrow-left"
                v-show="!hideBackIcon"></van-icon>
        <h1 class="app-header-title">{{ mapTitle?mapTitle:title }}</h1>
        <img class="menu-icon" src="../../../assets/nav1.png" @click="toggleNav" v-show="!hideNavIcon"/>
        <div class="nav-overlay" v-show="!hideNavMenu" @click="hideNavMenu = true">
            <ul class="nav-content">
                <li>
                    <router-link to="/preOrder">
                        <img src="../../../assets/nav_preorder.png" alt=""/>
                        <p>收件人下单</p>
                    </router-link>
                </li>
                <li>
                    <router-link to="/batchSentItem">
                        <img src="../../../assets/nav_batchorder.png" alt=""/>
                        <p>寄件人下单</p>
                    </router-link>
                </li>
                <li>
                    <!--                    <a href="http://cg1717.com/Contacts/">-->
                    <!--                        <img src="../../../assets/nav_dot.png" alt=""/>-->
                    <!--                        <p>网点查询</p>-->
                    <!--                    </a>-->
                    <router-link to="/search/branch">
                        <img src="../../../assets/nav_batchorder.png" alt=""/>
                        <p>网点查询</p>
                    </router-link>
                </li>
                <li>
                    <router-link to="/search/line">
                        <img src="../../../assets/nav_line.png" alt=""/>
                        <p>专线查询</p>
                    </router-link>
                </li>
                <li>
                    <router-link to="/search/logistics">
                        <img src="../../../assets/nav_wuliu.png" alt=""/>
                        <p>物流查询</p>
                    </router-link>
                </li>
                <li>
                    <router-link to="/order/myorder">
                        <img src="../../../assets/nav_myorder.png" alt=""/>
                        <p>我的订单</p>
                    </router-link>
                </li>
                <li>
                    <router-link to="/order/waybill">
                        <img src="../../../assets/icon_airport.png" alt=""/>
                        <p>我的运单</p>
                    </router-link>
                </li>
                <li>
                    <router-link to="/user">
                        <img src="../../../assets/nav_user.png" alt=""/>
                        <p>个人中心</p>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    export default {
        props: {
            title: {
                type: String,
                default: '云服卡航'
            },
            hideNavIcon: {
                type: Boolean,
                default: false
            },
            hideBackIcon: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState({
                mapTitle: (state) => state.mapTitle
            })
        },
        data() {
            return {
                hideNavMenu: true
            }
        },
        methods: {
            goBack() {
                this.$emit('go-back')
            },
            toggleNav() {
                this.hideNavMenu = !this.hideNavMenu
            }
        }
    }
</script>

<style scoped lang="scss">
    .app-header {
        position: relative;
        background-color: #042D6F;
        color: #fff;
        width: 100%;
        height: 1.17rem;
        padding: 0 0.25rem;
        box-sizing: border-box;
        font-size: 0.48rem;
        z-index: 9;

        .back-icon {
            position: absolute;
            left: 0.59rem;
            top: 50%;
            transform: translateY(-50%);
        }

        .app-header-title {
            height: 100%;
            line-height: 1.17rem;
            font-size: 0.45rem;
            text-align: center;
            font-weight: normal;
        }

        .menu-icon {
            position: absolute;
            right: 0.59rem;
            top: 50%;
            transform: translateY(-50%);
            height: 0.55rem;
            width: 0.61rem;
        }

        .nav-overlay {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 1000;
            background-color: transparent;

            .nav-content {
                position: absolute;
                top: 1.17rem;
                right: 0;
                background: #37363c;
                text-align: center;
                padding: 0.2rem;
                font-size: 0.3rem;
                z-index: 999;

                li {
                    border-bottom: 1px solid #57565b;
                    padding-bottom: 0.2rem;
                    margin-bottom: 0.2rem;

                    a {
                        color: #fff;

                        img {
                            width: 0.5rem;
                        }
                    }

                    p {
                        height: unset;
                    }

                    &:last-child {
                        padding-bottom: 0;
                        margin-bottom: 0;
                        border: 0;
                    }
                }
            }
        }
    }
</style>
